import React, { useCallback, useState } from 'react';

import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Popover from 'react-bootstrap/Popover';
import { Search } from 'react-bootstrap-icons';

import { Label } from '../../../Interface/Response/Interest/Label';

import useGetFilteredResults from '../../../Hook/UseGetFilteredResults';
import useGetLabels from '../../../Hook/Interest/UseGetLabels';

interface Props {
    onSelect: (label: Label) => void;
    selectedLabel?: Label;
}

interface State {
    showPopover: boolean;
    keyword: string;
}

const LabelSelectForm: React.FC<Props> = ({ onSelect, selectedLabel }: Props) => {
    const [state, setState] = useState<State>({ showPopover: false, keyword: '' });

    const { allLabels, activeLabel } = useGetLabels(true);
    const filteredLabels = useGetFilteredResults(allLabels, state.keyword, 0);

    const selectLabel = useCallback(
        (label: Label): void => {
            onSelect(label);
            setState({ ...state, showPopover: false });
        },
        [onSelect, state],
    );

    return (
        <>
            <Form className="popover-select-form" autoComplete="off">
                <Form.Group controlId="label-select">
                    <Form.Label>Zoek het product</Form.Label>
                    <InputGroup>
                        <InputGroup.Prepend>
                            <InputGroup.Text>
                                <Search />
                            </InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                            type="text"
                            className="rounded-right"
                            required
                            placeholder="Productnaam"
                            onChange={(e: any) => setState({ ...state, keyword: e.target.value })}
                            onFocus={() => setState({ ...state, showPopover: true })}
                        />
                        {filteredLabels.length > 0 && state.showPopover && (
                            <>
                                <div
                                    className="popover-backdrop"
                                    onClick={() => setState({ ...state, showPopover: false })}
                                    onKeyDown={() => setState({ ...state, showPopover: false })}
                                />
                                <Popover id="labels-popover" className="select" content placement="bottom">
                                    {filteredLabels.map(label => (
                                        <p
                                            key={label.findataCode}
                                            onClick={() => selectLabel(label)}
                                            onKeyDown={() => selectLabel(label)}
                                            className="d-flex align-items-center"
                                        >
                                            <img className="icon-sm mr-1" src={label.iconUrl} alt={label.label}/>
                                            {label.label}
                                        </p>
                                    ))}
                                </Popover>
                            </>
                        )}
                    </InputGroup>
                    {selectedLabel && selectedLabel.findataCode !== activeLabel?.findataCode && (
                        <div className="selected-value-wrapper">
                            <div className="selected-value-wrapper__value">
                                <img className="icon-sm mr-1" src={selectedLabel.iconUrl} alt={selectedLabel.label} />
                                {selectedLabel.label}
                            </div>
                        </div>
                    )}
                </Form.Group>
            </Form>
        </>
    );
};

export default LabelSelectForm;
